import React, { useState, useRef, useEffect } from 'react';

const TreatmentSlider = (props) => {

    const slider = useRef(null);
    const [autoPlay, setAutoPlay] = useState(0);

    useEffect(() => {
        if(autoPlay){
            const interval = setInterval(() => {
                selectNewImage(false, props.arrayImages);
            }, 2000)

            return () => clearInterval(interval);
        }
    });

    const selectNewImage = (btnTrigger = false, images, next = true) => {
        if(btnTrigger) {
            setAutoPlay(0);
        }
        setTimeout(() => {
            try{
            const sliderSize = (props.arrayImages.length - 1) * slider.current.offsetWidth;

            if (next) {
                slider.current.scrollLeft = (slider.current.scrollLeft >= (sliderSize - 10)) ? 0 : (slider.current.scrollLeft + slider.current.offsetWidth);
            }
            else {
                slider.current.scrollLeft = (slider.current.scrollLeft === 0) ? sliderSize : (slider.current.scrollLeft - slider.current.offsetWidth);
            }
            }
            catch(e){
                return;
            }
        }, 500);   
    }

    const previous = () => {
        selectNewImage(true, props.arrayImages, false);
    }

    const next = () => {
        selectNewImage(true, props.arrayImages);
    }


    return (
        <div className='treatment-slider-container'>
            <div ref={slider} className='treatment-slider'>
                {props.arrayImages.map((imgtest, index) => (<img key={index} src={process.env.PUBLIC_URL + imgtest.url} alt={imgtest.alt || 'Tratamiento de Vanity'} />))}
            </div>
            <div className='treatment-slider-buttons-container'>
                <button onClick={previous} className='btn-slider'><span>{'<'}</span></button>
                <button onClick={next} className='btn-slider'> <span>{'>'}</span></button>
            </div>
        </div>
    )
}

export default TreatmentSlider